<template>
	<div id="app">
		<div class="shareDownload">
			<div class="downloadBtn">
				<p>"小小明霞"</p>
				<p>邀请你加入Quick Live</p>
				<div @click="invitation_share_btn">
					立即下载
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '@/assets/css/style.css'
	import axios from 'axios'
	 import Toast from "vant/lib/toast"
	import QRCode from 'qrcodejs2'
	import { judgeIosAndroid } from '@/assets/js/models.js'
	export default {
		data() {
			return {
				 url: ''
			}
		},
		created: function() {
			document.title = "分享下载";
			this.convert()
		},
		  mounted() {
		  // 将要给原生调用的方法挂载到 window 上面
		  window.mobile_intercept = this.mobile_intercept
		},
		  methods: {
		  creatQrCode() {
		    var qrcode = new QRCode(this.$refs.qrCodeUrl, {
		      text: this.url, // 需要转换为二维码的内容
		      width: 200,
		      height: 200,
		      colorDark: '#000000',
		      colorLight: '#ffffff',
		      correctLevel: QRCode.CorrectLevel.H
		    })
		  },
		  invitation_share_btn () {
		    // 分享拦截
		    this.mobile_intercept(this.url)
		  },
		  mobile_intercept(url) {
		    //  拦截
		    const isIos = judgeIosAndroid();
		    if (isIos == true) {
		      // ios传值方法postMessage（val）传值方式
		      window.webkit.messageHandlers.distribution_share.postMessage(url)
		    } else {
		      // ios传值方法goSubmitted（val）传值方式
		      window.AndroidJs.distribution_share(url)
		    }
		  },
		  convert: function() {
		    const token = this.$route.query.token
		    axios.post(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=invite_share&token="+token).then(res =>{
		      console.log(res.data)
		      if(res.data.status != 1){
		        Toast(res.data.error);
		      }
		      this.url = res.data.data.url
		      this.creatQrCode()
		    })
		  }
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shareDownload.vue